var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableiconsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.83398V17.1673M3 12.5007H18M3 8.83398H18M5.66667 17.1673H15.3333C16.2667 17.1673 16.7335 17.1673 17.09 16.9856C17.4036 16.8259 17.6586 16.5709 17.8183 16.2573C18 15.9008 18 15.4341 18 14.5006V6.50065C18 5.56723 18 5.10052 17.8183 4.744C17.6586 4.43039 17.4036 4.17543 17.09 4.01564C16.7335 3.83398 16.2667 3.83398 15.3333 3.83398H5.66667C4.73325 3.83398 4.26653 3.83398 3.91002 4.01564C3.59641 4.17543 3.34144 4.43039 3.18166 4.744C3 5.10052 3 5.56723 3 6.50065V14.5006C3 15.4341 3 15.9008 3.18166 16.2573C3.34144 16.5709 3.59641 16.8259 3.91002 17.0073C4.26653 17.1673 4.73324 17.1673 5.66667 17.1673Z",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableiconsvg);
export default __webpack_public_path__ + "static/media/tableiconsvg.1a7610b8f196d99d64d289e87b424071.svg";
export { ForwardRef as ReactComponent };